var $ = require('jquery');
var LazyLoad = require('lazyloader');
var PubSub = require('./pub-sub');
var PubSubMessageKeys = require('utils/pubSubMessageKeys');

var DependencyLoader = function() {
  return {
    pubSubMessageKeys: PubSubMessageKeys,
    loadDependencies: function(frag) {
      var _self = this;
      var componentTags = '';
      var cssTags = [], jsTags = [];
      var fragTags = frag.filter('script.component-tag');

      frag.filter('link.component-tag[rel="stylesheet"]').each(function() {
        cssTags.push($(this).attr('href'));
      });

      LazyLoad.css(cssTags, function() {
        'use strict';
        fragTags.filter('script.component-tag').each(function() {
          var src = $(this).attr('src');
          if (src) {
            jsTags.push(src);
          } else {
            eval($(this).text());
          }
        });

        LazyLoad.js(jsTags, function() {
          PubSub.publishGlobal(PubSubMessageKeys.GLOBAL_RENDER);
        });
      });

      frag.filter('script[type=\'text/mi-context\']').each(function(i, tag) {
        $('body').prepend(tag);
      });

    }
  };
};

module.exports = DependencyLoader;
